module.exports = __webpack_public_path__ + "static/media/prb-nutri-site-logo-identidade-visual.58b78265.jpg";